import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    viewingRequestMeeting: false,
    viewingMedicalInformation: false,

    viewingPDF: false,
    pdfTitle: '',
    pdfURL: '',

    viewingLargeWeb: false,
    viewingWeb: false,
    webTitle: '',
    webURL: '',

    viewingVideo: false,
    videoTitle: '',
    videoURL: '',

    viewingResourceList: false,
    currentResourceListTitle: '',
    currentResourceList: []
  },
  mutations: {
    viewingRequestMeeting(state, value: boolean) { state.viewingRequestMeeting = value; },
    viewingMedicalInformation(state, value: boolean) { state.viewingMedicalInformation = value; },

    openPDF(state, payload: { url: string, title: string, count: number }) {
      state.pdfTitle = payload.title;
      state.pdfURL = payload.url;
      state.viewingPDF = true;
    },
    viewingPDF(state, value: boolean) { state.viewingPDF = value; },

    openWeb(state, payload: { url: string, title: string }) {
      state.webTitle = payload.title;
      state.webURL = payload.url;
      state.viewingWeb = true;
    },
    viewingWeb(state, value: boolean) { state.viewingWeb = value; },

    openLargeWeb(state, payload: { url: string, title: string }) {
      state.webTitle = payload.title;
      state.webURL = payload.url;
      state.viewingLargeWeb = true;
    },
    viewingLargeWeb(state, value: boolean) { state.viewingLargeWeb = value; },

    openVideo(state, payload: { url: string, title: string }) {
      state.videoTitle = payload.title;
      state.videoURL = payload.url;
      state.viewingVideo = true;
    },
    viewingVideo(state, value: boolean) { state.viewingVideo = value; },

    openResourceList(state, payload: { resources: [], title: string }) {
      state.currentResourceListTitle = payload.title;
      state.currentResourceList = payload.resources;
      state.viewingResourceList = true;
    },
    viewingResourceList(state, value: boolean) { state.viewingResourceList = value; },
  },
  actions: {
  },
  modules: {
  }
});
